// extracted by mini-css-extract-plugin
module.exports = {"Message":"Message_Message__2fF6f","hideMessage":"Message_hideMessage__3Maq_"};